import { render, staticRenderFns } from "./BindCard2.vue?vue&type=template&id=4ec47168&scoped=true"
import script from "./BindCard2.vue?vue&type=script&lang=js"
export * from "./BindCard2.vue?vue&type=script&lang=js"
import style0 from "./BindCard2.vue?vue&type=style&index=0&id=4ec47168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec47168",
  null
  
)

export default component.exports